import React from "react";
import { useTranslation } from "react-i18next";
// import lightLogo from '../assets/images/light-logo.svg';

const Products = () => {

    const { t,i18n } = useTranslation();
    const currentLanguage = i18n.language;

    return (
        

        <section className="journey">
            {/* <img src={lightLogo} alt="baner-image" className='logo-white'/> */}
            <div className="container">
                <div className="journey-text">
                    <h3 style={{ transform: currentLanguage == 'ar' ? "scaleX(-1)" :  "scaleX(1)"  ,textAlign : currentLanguage == 'ar' ? 'right' : 'left'}}>{t('homeMainSlider.card2.title')}</h3>
                    <h4 style={{ transform: currentLanguage == 'ar' ? "scaleX(-1)" :  "scaleX(1)"  ,textAlign : currentLanguage == 'ar' ? 'right' : 'left'}}>{t('homeMainSlider.card2.subtitle')}</h4>
                </div>
            </div>
        </section>
    );
}

export default Products;